var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPinLogin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ellipsis.viewfinder",
    transform: "translate(0 0.015)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6524",
    "data-name": "Rectangle 6524",
    width: 80,
    height: 80,
    transform: "translate(0 -0.015)",
    fill: "#333",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9339",
    "data-name": "Group 9339",
    transform: "translate(0 -0.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12787",
    "data-name": "Path 12787",
    d: "M3.269,26.015a3.006,3.006,0,0,0,3.309-3.352V13.015c0-4.251,2.247-6.418,6.333-6.418H22.8a3.007,3.007,0,0,0,3.35-3.311c0-2.126-1.185-3.27-3.35-3.27H12.829Q.02.016,0,12.647V22.663A3.013,3.013,0,0,0,3.269,26.015Zm73.422,0A3.007,3.007,0,0,0,80,22.663V12.647Q80,.016,67.171.016H57.16a2.964,2.964,0,0,0-3.309,3.27A2.994,2.994,0,0,0,57.16,6.6h9.887c4.045,0,6.374,2.167,6.374,6.418v9.647A3.013,3.013,0,0,0,76.691,26.015Zm-63.861,54H22.8a3.291,3.291,0,1,0,0-6.581H12.911c-4.086,0-6.333-2.167-6.333-6.418V57.369a3.007,3.007,0,0,0-3.309-3.352C1.144,54.016,0,55.2,0,57.369v9.974Q0,80.036,12.829,80.016Zm44.331,0h10.01C75.71,80.016,80,75.764,80,67.343V57.369a3.007,3.007,0,0,0-3.309-3.352c-2.125,0-3.269,1.186-3.269,3.352v9.647c0,4.251-2.329,6.418-6.374,6.418H57.16a3.291,3.291,0,1,0,0,6.581Z",
    transform: "translate(0 0.063)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12788",
    "data-name": "Path 12788",
    d: "M16.088,18.378a5.927,5.927,0,1,0-5.924-5.927A5.93,5.93,0,0,0,16.088,18.378Z",
    transform: "translate(42.992 27.608)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12789",
    "data-name": "Path 12789",
    d: "M12.448,18.378a5.927,5.927,0,1,0-5.924-5.927A5.922,5.922,0,0,0,12.448,18.378Z",
    transform: "translate(27.593 27.608)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12790",
    "data-name": "Path 12790",
    d: "M8.8,18.378a5.927,5.927,0,1,0-5.924-5.927A5.93,5.93,0,0,0,8.8,18.378Z",
    transform: "translate(12.16 27.608)",
    fill: "#333"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPinLogin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pin_login.e1d0d9f7.svg";
export { ForwardRef as ReactComponent };